<template>
  <v-dialog v-model="dialog" width="600" height="400" persistent scrollable>
    <v-card>
      <v-card-title class="headline orange lighten-3 d-flex flex-row">
        <v-layout align-center>
          <v-flex grow>
            <template v-if="options.icon">
              <v-icon color="green">{{options.icon}}</v-icon>&nbsp;
            </template>
            <span binding:style="color: options.color;">{{title}}</span>
          </v-flex>
          <v-spacer />
          <v-btn flat icon class="align--right" @click.stop="cancel('closed')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-divider />
      <v-card-title>
        <v-flex style="padding: 0 30px; ">
          <v-text-field
            v-model="note"
            :label="options.subTitle"
            type="text"
            append-icon="done_outline"
            @click:append="accept(note)"
          ></v-text-field>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ConfirmDialog',
  data: () => ({
    dialog: false,
    title: 'Title',
    note: 'Something happens',
    options: {
      backgroundColor: 'yellow',
      color: 'navy',
      icon: 'content_paste',
      subTitle: 'Input a note: '
    },
    resolve: null,
    reject: null,
  }),

  methods: {
    open(title, note, options) {
      this.title = title;
      this.note = note;
      if (options) {
        Object.assign(this.options, options)
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    accept(str) {
      this.dialog = false;
      this.resolve(str);
    },
    cancel(str) {
      this.dialog = false;
      this.reject(str);
    }
  },
}
</script>

<style scoped>
  .v-card__title {
    padding: 8px 16px;
  }
  .selected {
    background-color: lightseagreen;
  }
</style>